import { Badge } from '../types/fingeringEditor';
import { BADGE_SINGLE_R as BADGE_HIT_RADIUS } from '../pages/fingering/components/BadgeSvg';

/** 範囲選択用の矩形 (caller 側で min/max に正規化済みを期待)。 */
export interface SelectionRect {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
  /** 対象とする SVG ページ番号。 */
  page: number;
}

/**
 * 矩形 AABB ヒットテストで matched badges を返す純関数。
 * badge.page === rect.page のみ対象。badge の hit radius を含めた拡張 AABB で
 * 交差判定する。caller は事前に min/max 順序を正規化しておく必要がある。
 */
export function badgesInRect(badges: Badge[], rect: SelectionRect): Badge[] {
  const result: Badge[] = [];
  for (const b of badges) {
    if (b.page !== rect.page) continue;
    // AABB 拡張: badge.x ± R が rect の min/max と交差するかを判定。
    const xMin = b.x - BADGE_HIT_RADIUS;
    const xMax = b.x + BADGE_HIT_RADIUS;
    const yMin = b.y - BADGE_HIT_RADIUS;
    const yMax = b.y + BADGE_HIT_RADIUS;
    if (xMax < rect.minX) continue;
    if (xMin > rect.maxX) continue;
    if (yMax < rect.minY) continue;
    if (yMin > rect.maxY) continue;
    result.push(b);
  }
  return result;
}
